import { useContext } from "react";
import { getById } from "sprint-common-web";

import { LanguageSpecificationsDataContext } from "../../../../../common/data/lookup-data-providers/LanguageSpecificationsDataProvider";
import { MuxSpecificationsDataContext } from "../../../../../common/data/lookup-data-providers/MuxSpecificationsDataProvider";
import { useAdminAirlineApi } from "../../../../airline/common/api/useAdminAirlineApi";
import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { EditEncodeConfigurationFormInputs } from "./EditEncodeConfigurationForm";

export const useEditEncodeConfigurationForm = (systemId: string) => {
    const { updateEncodeConfiguration } = useAdminAirlineApi();

    const {
        systemPlatformDetailsItem,
        updateEncodeConfiguration: updateEncodeConfigurationItem,
        resetSpecifications
    } = useContext(SystemPlatformDetailsContext);

    const { muxSpecifications } = useContext(MuxSpecificationsDataContext);
    const { languageSpecifications } = useContext(LanguageSpecificationsDataContext);

    const itemToEdit = {
        ...systemPlatformDetailsItem.encodeConfiguration
    };

    const editEncodeConfiguration = async ({
        muxSpecificationId,
        subtitlesTargetFileName,
        audioProxyType,
        muxSubtitleType,
        copySubtitleType,
        closedCaptionCode,
        subtitlesCaptionCode,
        languageSpecificationId
    }: EditEncodeConfigurationFormInputs) => {
        await updateEncodeConfiguration({
            airlineId: systemPlatformDetailsItem.airline.id,
            systemId,
            muxSpecificationId,
            subtitlesTargetFileName,
            audioProxyType: Number(audioProxyType),
            muxSubtitleType: muxSubtitleType ? Number(muxSubtitleType) : undefined,
            copySubtitleType: copySubtitleType ? Number(copySubtitleType) : undefined,
            closedCaptionCode,
            subtitlesCaptionCode,
            languageSpecificationId
        });

        const muxSpecification = getById(muxSpecifications, muxSpecificationId);
        const languageSpecification = languageSpecifications.find(
            (languageSpec) => languageSpec.id === languageSpecificationId
        );

        if (
            systemPlatformDetailsItem.encodeConfiguration.muxSpecification &&
            muxSpecification.encodeSpecificationType !==
                systemPlatformDetailsItem.encodeConfiguration.muxSpecification?.encodeSpecificationType
        ) {
            resetSpecifications();
        }

        updateEncodeConfigurationItem({
            muxSpecification: muxSpecification,
            audioProxyType: Number(audioProxyType),
            muxSubtitleType: muxSubtitleType ? Number(muxSubtitleType) : undefined,
            copySubtitleType: copySubtitleType ? Number(copySubtitleType) : undefined,
            subtitlesTargetFileName,
            closedCaptionCode,
            subtitlesCaptionCode,
            languageSpecification
        });
    };

    return {
        itemToEdit,
        muxSpecifications,
        languageSpecifications,
        editEncodeConfiguration
    };
};
